const angular = require('angular');
const app = angular.module('learn-directives');
var tuiImageEditorImport = require('../imports/tui-image-editor');

/**
 * Defines the users profile edit component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('userProfileEdit', ['Application', 'Authorization', 'Users', 'Skills', 'Meets', 'Analyze', '$translate', 'S3Uploads', 'Upload', 'i18n', '$sce', function (Application, Authorization, Users, Skills, Meets, Analyze, $translate, S3Uploads, Upload, i18n, $sce) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/user-profile-edit.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.user = Authorization.getAuthToken().user;
        self.brandColor = Application.colors.get().slice(0, 1);
        self.languages = Application.languages.getAvailable();
        self.flags = Application.features.flags();
        var langTranslations = self.languages.map(function(item) {return item.name});

        // black theme 
        var blackTheme = {
          'common.bi.image': 'https://uicdn.toast.com/toastui/img/tui-image-editor-bi.png',
          'common.bisize.width': '251px',
          'common.bisize.height': '21px',
          'common.backgroundImage': Application.tuiBgImage,
          'common.backgroundColor': '#fff',
          'common.border': '1px solid #c1c1c1',
      
          // header
          'header.backgroundImage': 'none',
          'header.backgroundColor': 'transparent',
          'header.border': '0px',
      
          // load button
          'loadButton.backgroundColor': '#fff',
          'loadButton.border': '1px solid #ddd',
          'loadButton.color': '#222',
          'loadButton.fontFamily': '\'Gotham Rounded SSm A\', \'Gotham Rounded SSm B\', sans-serif',
          'loadButton.fontSize': '12px',
      
          // download button
          'downloadButton.backgroundColor': '#fdba3b',
          'downloadButton.border': '1px solid #fdba3b',
          'downloadButton.color': '#fff',
          'downloadButton.fontFamily': '\'Gotham Rounded SSm A\', \'Gotham Rounded SSm B\', sans-serif',
          'downloadButton.fontSize': '12px',
      
          // main icons
          'menu.normalIcon.path': 'icon-d.svg',
          'menu.normalIcon.name': 'icon-d',
          'menu.activeIcon.path': 'icon-b.svg',
          'menu.activeIcon.name': 'icon-b',
          'menu.disabledIcon.path': 'icon-a.svg',
          'menu.disabledIcon.name': 'icon-a',
          'menu.hoverIcon.path': 'icon-c.svg',
          'menu.hoverIcon.name': 'icon-c',
          'menu.iconSize.width': '24px',
          'menu.iconSize.height': '24px',
      
          // submenu primary color
          'submenu.backgroundColor': 'transparent',
          'submenu.partition.color': '#e5e5e5',
      
          // submenu icons
          'submenu.normalIcon.path': 'icon-d.svg',
          'submenu.normalIcon.name': 'icon-d',
          'submenu.activeIcon.path': 'icon-b.svg',
          'submenu.activeIcon.name': 'icon-b',
          'submenu.iconSize.width': '32px',
          'submenu.iconSize.height': '32px',
      
          // submenu labels
          'submenu.normalLabel.color': '#858585',
          'submenu.normalLabel.fontWeight': 'normal',
          'submenu.activeLabel.color': '#000000',
          'submenu.activeLabel.fontWeight': 'normal',
      
          // checkbox style
          'checkbox.border': '1px solid #ccc',
          'checkbox.backgroundColor': '#fff',
      
          // rango style
          'range.pointer.color': self.brandColor,
          'range.bar.color': '#858585',
          'range.subbar.color': self.brandColor,
      
          'range.disabledPointer.color': '#d3d3d3',
          'range.disabledBar.color': 'rgba(85,85,85,0.06)',
          'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',
      
          'range.value.color': '#858585',
          'range.value.fontWeight': 'normal',
          'range.value.fontSize': '11px',
          'range.value.border': '0',
          'range.value.backgroundColor': '#858585',
          'range.title.color': '#858585',
          'range.title.fontWeight': 'lighter',
      
          // colorpicker style
          'colorpicker.button.border': '0px',
          'colorpicker.title.color': '#858585'
        };

        var originalUser;
        var userQuery = {
          subresource: self.user._id,
          fields: 'first_name,last_name,full_name,email,role,is_collaborator,image,banner_image,skills,social_links,about,provisioning_status,language',
          'skills-populate': 'name'
        };

        self.saveUser = function(body) {
          return Users.update(userQuery, body).$promise
          .then(function(user) {
            if (!originalUser.image && user.image !== originalUser.image) {
              Analyze.record({resource: 'avatars'}, {image: user.image});
            }
            if (!user.skills) {
              user.skills = [];
            }
            originalUser = JSON.parse(JSON.stringify(user));
            self.profile = user;
            Application.messaging.addMessage({type: 'success', duration: 3, text: 'Profile Saved!'});
            return user;
          });
        };

        self.details = {
          loading: false,
          options: ['first_name', 'last_name', 'email', 'about', 'language'],
          updateAvailable: false,
          showMeetsSection: false,
          change: function() {
            for (var i = 0; i < this.options.length; i++) {
              if (self.profile[this.options[i]] !== originalUser[this.options[i]]){
                this.updateAvailable = true;
                return;
              }
            }
            this.updateAvailable = false;
          },
          update: function() {
            if (!self.profile.first_name || !self.profile.last_name || !self.profile.email) {
              Application.messaging.addMessage({type: 'error', duration: 6, text: 'First Name, Last Name, and Email Address are all required fields.'});
              return;
            }
            var body = {
              first_name: self.profile.first_name,
              last_name: self.profile.last_name,
              about: self.profile.about,
              language: self.profile.language
            };

            this.loading = true;

            self.saveUser(body)
            .then(function(user) {
              self.details.loading = false;
              self.details.updateAvailable = false;
              const authToken = Authorization.getAuthToken();
              authToken.user.language = user.language;
              Authorization.saveAuthToken(authToken);
            }).catch(function(error) {

            });
          }
        };

        self.skills = {
          loading: false,
          term: '',
          toCreate: [],
          options: [],
          updateAvailable: false,
          originalSkills: [],
          update: function(body) {
            body = body || {skills: self.profile.skills.map(function(item) {return item._id})};
            this.loading = true;
            self.saveUser(body)
            .then(function(user) {
              self.skills.loading = false;
              self.skills.updateAvailable = false;
              self.skills.originalSkills = originalUser.skills ? originalUser.skills.map(function(item){return item._id}) : [];
            }).catch(function(error) {

            });
          },
          remove: function(skill) {
            for (var i = 0; i < self.profile.skills.length; i++) {
              if (skill._id && self.profile.skills[i]._id === skill._id) {
                self.profile.skills.splice(i, 1);
                this.checkUpdate();
                return;
              }
              if (!skill._id && !self.profile.skills[i]._id && self.profile.skills[i].name === skill.name) {
                var removed = self.profile.skills.splice(i, 1);
                this.checkUpdate();
                var removedIndex = this.toCreate.indexOf(removed);
                if (removedIndex !== -1) {
                  this.toCreate.splice(removedIndex, 1);
                }
                return;
              }
            }
          },
          keyPress: function(event) {
            if (event.which !== 13 || !this.term) {
              return;
            }
            this.addSkill(this.term);
          },
          addSkill: function(item, selected) {
            if (selected) {
              for (var i = 0; i < self.profile.skills.length; i++) {
                if (self.profile.skills[i]._id === item._id) {
                  Application.messaging.addMessage({type: 'error', duration: 5, text: 'You already have this skill.'});
                  return;
                }
              }
              self.profile.skills.push(item);
              this.checkUpdate();
              this.term = '';
              return;
            }
            for (var i = 0; i < self.profile.skills.length; i++) {
              if (self.profile.skills[i]._id) {
                continue;
              }
              if (self.profile.skills[i].name === item) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: 'You already have this skill.'});
                return;
              }
            }
            this.checkForBlocked(item, self.profile.skills.length, this.toCreate.length);
            self.profile.skills.push({name: item});
            this.checkUpdate();
            this.toCreate.push(item);
            this.term = '';
          },
          checkForBlocked: function(name, skillsIndex, createIndex) {
            Skills.find({name: name, blocked: true}).$promise
            .then(function(skills) {
              if (skills.length) {
                var blocked = self.profile.skills.splice(skillsIndex, 1);
                self.profile.toCreate.splice(createIndex, 1);
                Application.messaging.addMessage({type: 'error', duration: 5, text: 'The skill ' + blocked + ' is blocked and has been removed.'});
              }
            });
          },
          createAndSave: function() {
            if (this.loading) {
              return;
            }
            if (!this.toCreate.length) {
              this.update();
              return;
            }
            this.loading = true;
            Skills.createMultiple({}, {skills: this.toCreate, user: self.user._id}).$promise
            .then(function(skills) {
              var created = {};
              var body = {skills: []};
              skills.forEach(function(skill) {
                if (!skill.name || !skill._id) {
                  return;
                }
                created[skill.name] = skill._id;
              });
              self.profile.skills.forEach(function(skill) {
                if (skill._id) {
                  body.skills.push(skill._id);
                  return;
                }
                if (created[skill.name]) {
                  body.skills.push(created[skill.name]);
                }
              });
              self.skills.update(body);
            }).catch(function(error) {
            });
          },
          checkUpdate: function() {
            if (!this.originalSkills.length && originalUser.skills && originalUser.skills.length) {
              this.originalSkills = originalUser.skills.map(function(item){return item._id});
            }
            if (this.originalSkills.length !== self.profile.skills.length) {
              this.updateAvailable = true;
              return;
            }
            for (var i = 0; i < self.profile.skills.length; i++) {
              if (!self.profile.skills[i]._id || this.originalSkills.indexOf(self.profile.skills[i]._id) === -1) {
                this.updateAvailable = true;
                return;
              }
            }
            this.updateAvailable = false;
          }
        };

        $scope.$watch('profileEdit.skills.term', function(newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          if (!newVal || newVal.length < 3) {
            self.skills.options.splice(0);
            return;
          }

          Skills.find({
            subresource: '',
            page: 1,
            per_page: 8,
            fields: 'name',
            blocked: '$ne,true',
            name: '$regex,2,' + self.skills.term + ',i'
          }).$promise.then(function(skills) {
            if (skills.length) {
              self.skills.options = skills;
              return;
            }
            self.skills.options.splice(0);
          });
        });

        self.social = {
          loading: false,
          updateAvailable: false,
          links: {},
          originalLinks: {},
          options: {'linkedin': true, 'twitter': true, 'facebook': true, 'instagram': true, 'dribbble': true, 'github': true},
          init: function() {
            if (!self.profile.social_links) {
              self.profile.social_links = [];
              return;
            }
            self.profile.social_links.forEach(function(item) {
              if (!item.name || !item.value) {
                return;
              }
              if (self.social.options[item.name] && item.value) {
                self.social.links[item.name] = item.value;
                self.social.originalLinks[item.name] = item.value;
              }
            });
          },
          update: function() {
            this.loading = true;
            var links = [];
            for (var key in this.links) {
              if (!this.links[key]) {
                continue;
              }
              links.push({name: key, value: this.links[key]});
            }
            self.saveUser({social_links: links})
            .then(function(user) {
              self.social.init();
              self.social.loading = false;
              self.social.updateAvailable = false;
            }).catch(function(error) {
              let errorMessage = 'Error saving profile';
              if (error.data && error.data.message) {
                errorMessage = error.data.message;
              }
              Application.messaging.addMessage({type: 'error', duration: 3, text: errorMessage});
              self.social.loading = false;
            });
          },
          change: function(type) {
            var items = Object.keys(this.options);
            for (var i = 0; i < items.length; i++) {
              if (this.links[items[i]] !== this.originalLinks[items[i]]) {
                this.updateAvailable = true;
                return;
              }
            } 
            this.updateAvailable = false;
          }
        };

        self.images = {
          editorState: {
            'available': null
          },
          avatar: {
            image: '',
            active: false,
            loading: false,
            percent: null,
            image_name: '',
            cropped: '',
            old: '',
            remove: function() {
              self.images.avatar.old = self.profile.image;
              self.saveUser({image: ''});
            },
            cancelCrop: function() {
              self.images.avatar.image = '';
              self.images.avatar.cropped = '';
              self.images.avatar.active = false;
              self.images.avatar.loading = false;
              self.images.avatar.apply = false;
              self.images.avatar.percent = null;
            },
            crop: function(link) {
              if (!link) {
                return;
              }

              self.images.updateImage('image', link);
              self.images.avatar.cancelCrop();
            }
          },
          banner: {
            image: '',
            active: false,
            loading: false,
            percent: null,
            image_name: '',
            modifiedLink: '',
            editInit: async function(imageUrl) {
              const tuiImageEditorModule = await tuiImageEditorImport.importModule();
              const ImageEditor = tuiImageEditorModule.default;
              self.editInstance = new ImageEditor(document.querySelector('#banner-editor'), {
                usageStatistics: false,
                includeUI: {
                  loadImage: {
                    path: imageUrl,
                    name: 'SampleImage'
                  },
                  menu: ['filter', 'crop', 'flip', 'rotate'],
                  theme: blackTheme,
                  menuBarPosition: 'bottom'
                },
                cssMaxWidth: (document.documentElement.clientWidth - 200 ),
                cssMaxHeight: (document.documentElement.clientHeight - 200 ),
                selectionStyle: {
                  borderColor: 'white',
                  cornerColor: self.brandColor,
                  cornerSize: 40,
                  rotatingPointOffset: 100,
                  transparentCorners: false
                }
              });

              window.onresize = function() {
                self.editInstance.ui.resizeEditor();
              };

              setTimeout(function() {
                document.querySelector('.tui-image-editor-header').style.display = 'none';
                self.images.banner.active = true;
                $scope.$apply();
              }, 5);
            },
            editorSave: function() {
              function dataURItoBlob(dataURI) {
                var binary = atob(dataURI.split(',')[1]);
                var array = [];
                for(var i = 0; i < binary.length; i++) {
                    array.push(binary.charCodeAt(i));
                }
                return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
              }

              var img = self.editInstance.toDataURL({format: 'jpeg'});
              var file = new File([dataURItoBlob(img)], 'uploaded-img.jpeg');

              self.images.banner.loading = true;
              self.images.banner.percent = 0;

              self.images.banner.active = false;
              S3Uploads.imagePolicy({fileName: file.name, contentType: file.type}, function(data) {
                var cloudFrontLink = data.CloudFrontLink;
                Upload.upload({
                  url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
                  headers: {'Remove-auth': 'yes'},
                  method: 'POST',
                  data: {
                    key: data.Key,
                    'Content-Type': data.ContentType,
                    AWSAccessKeyId: data.AWSAccessKeyId,
                    'success_action_status': '201',
                    policy: data.S3Policy,
                    signature: data.S3Signature
                  },
                  file: file
                }).progress(function(evt) {
                  var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
                    self.images.banner.percent = percent;
                }).success(function(data) {
                  var link = cloudFrontLink;
                  if (!link) {
                    return;
                  }
                  self.images.updateImage('banner_image', link);
                  self.images.banner.image = '';
                  self.images.banner.loading = false;
                  self.images.banner.editorCancel();
                  Application.scrollTop();
                }).catch(function(error) {
                  console.log('upload error', error);
                });
              }, function(error) {
                console.log('s3url error', error);
                Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
              });
            },
            editorCancel: function() {
              self.images.banner.active = false;
              self.editInstance = null;
            },
            getImage: function() {
              return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + ',' + 'q_auto:eco' + '/' + ( (self.profile && self.profile.banner_image) ? self.profile.banner_image : 'https://d2277n3gvptnup.cloudfront.net/images/51d5f21b2f410a020b000002/cb4e0e69-b263-43a6-aa1d-f73d8325688c.jpg');
            }
          },
          progress: function(type) {
            if (self.images[type].percent === null) {
              return 0 + '';
            }
            return self.images[type].percent - 100 + '%';
          },
          updateImage: function(type, image) {
            var body = {};
            var main = this;
            body[type] = image;
            self.saveUser(body)
            .then(function(user) {
              if (type === 'image') {
                self.images.avatar.loading = false;
                self.images.avatar.active = false;
                Authorization.updateImage('image', user.image);
                return;
              }
              self.images.banner.loading = false;
              self.images.banner.active = false;
              Authorization.updateImage('banner_image', user.image);
            }).catch(function(error) {
            });
          }
        };

        self.preview = function() {
          Application.navigation.goTo('/profile/' + self.profile._id);
        }
        $scope.$watch('profileEdit.profile.language', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal || !oldVal) {
            return;
          }
          self.details.change();
          self.isLanguages = false;
          $translate.use(newVal)
          .then(function() {
            $translate(langTranslations, {}, undefined, undefined, newVal).then(function(data){
              self.languages = Application.languages.getAvailable();
              self.languages.forEach(function(item) {
                if (data[item.key]) {
                  item.name = $sce.valueOf(data[item.key]);
                }
              });
              self.isLanguages = true;
            });

          });
        });

        // Watches the value passed to the image Upload
        $scope.$watch('profileEdit.images.avatar.image', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }

          self.images.avatar.active = true;
        });

        // Watches the value passed to the banner Upload
        $scope.$watch('profileEdit.images.banner.image', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }

          self.images.banner.active = true;
          setTimeout(function() {
            self.images.banner.editInit(self.images.banner.image);          
          }, 5);
        });

        self.disableMeets = function() {
          Meets.uninstall({}).$promise.then(function(results) {
            self.checkMeets(null, true);
            Application.messaging.addMessage({type: 'success', duration: 5, text: 'Integration successfully revoked.'});
          }).catch(function(error) {
            self.checkMeets(originalUser);
            Application.messaging.addMessage({type: 'error', duration: 5, text: 'There was an issue revoking the integration.'});
          });
        };

        self.checkMeets = function(user, forceEnabled) {
          if (!self.flags.enable_google_meets) {
            return;
          }

          Meets.existsWithUser({}).$promise.then(function (results) {
            self.meetsUserEnabled = (results.exists) || false;
            self.details.showMeetsSection = self.meetsUserEnabled;

            if (forceEnabled) {
              self.details.showMeetsSection = true;
              return;
            }

            if (!self.meetsUserEnabled) {
              if (['admin', 'creator'].indexOf(user.role) !== -1 || user.is_collaborator) {
                self.details.showMeetsSection = true;
              }
            }

          });
        };

        self.initialize = function() {
          Users.get(userQuery).$promise.then(function(user) {
            self.checkMeets(user);
            if (user.language && user.language.toLowerCase() === 'eng') {
              user.language = 'en';
            }
            if (!user.skills) {
              user.skills = [];
            }
            originalUser = JSON.parse(JSON.stringify(user));
            self.initialized = true;
            self.profile = user;
            self.social.init();
            self.showPassword = user.provisioning_status !== 'provisioning' && user.provisioning_status !== 'provisioned';
            $scope.$watch('profileEdit.profile.language', function(newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              i18n.language(newVal);
            });
          }).catch(function(error) {

          });

        };

        $scope.$on('$destroy', function() {
          if (self.profile && originalUser.language && originalUser.language !== self.profile.language) {
            i18n.language(originalUser.language);
            Authorization.getAuthToken().user.language = originalUser.language;
          }
        });

        var translateValues = function(init) {
          self.isLanguages = false;
          $translate([
            'modules.notifications.profile_updated',
            'modules.notifications.canNotUpdateProfile',
            'modules.notifications.unableToGetUserTracks',
            'manage.users.location',
            'manage.users.selectALocation',
            'global.actions.cancel',
            'global.actions.delete'
          ].concat(langTranslations)).then(function(data){
            self.translations = data;

            self.languages = Application.languages.getAvailable();
            self.languages.forEach(function(item) {
              if (data[item.name]) {
                item.name = data[item.name];
              }
            });

            setTimeout(function() {
              self.isLanguages = true;
              $scope.$apply();
            }, 100);

            if (init) {
              self.initialize();
            }
          });
        };

        translateValues(true);



      }],
      controllerAs: 'profileEdit'
    };
  }]);



